import React, {   useState } from "react";
import { ColumnDirective, ColumnsDirective,Grid, Resize, GridComponent, Inject, Page, Sort, Filter, Group } from '@syncfusion/ej2-react-grids';
import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import useSave from "../../Hooks/useSave";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import useValidateRole from "../../Hooks/useValidateRole";
import Select from "react-select";
import useFetchData from "../../Hooks/useFetchData";
import Api from "../../Hooks/Api";
import { Progress } from "reactstrap";
var dateFormat = require("dateformat");
const Governances = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setview] = useState(false);
  const [update, setUpdate] = useState(false);
  const [PageRole, setPageRole] = useState("Governances");
  const GovernanceRoles = useFetchData("api/GovernanceRoles");
  const Qualifications = useFetchData("api/Qualifications");
  const Institutions = useFetchData("api/DashBoard/ApprovedInstitutions");
  const Disabilities = useFetchData("api/Disabilities");
  const Ethnicities = useFetchData("api/Ethnicities");
  const [message, setmessage] = useState("");
  const [selectedFile, setselectedFile] = useState("");
  const [loaded, setloaded] = useState("");
  const url = "api/Governances";
  let grid= Grid | null;
  const dataurl = process.env.REACT_APP_BASE_URL + 'api/Governances/AllGovernances';

  
  const handleOpenModal = (event) => {
    //event.persist();
    setInputs({});
    setOpen(true);
  };

  const onChangeHandler = (event) => {
    //for multiple files
    var files = event.target.files;
    if (maxSelectFile(event)) {
      setselectedFile(files);
      setloaded(0);
    }
  };
  const onClickHandler = (event) => {
    event.preventDefault();
    if (selectedFile) {
      const data = new FormData();

      for (var x = 0; x < selectedFile.length; x++) {
        data.append("file", selectedFile[x]);
      }
      Api.post("/api/Upload", data, {
          // receive two parameter endpoint url ,form data
          onUploadProgress: (ProgressEvent) => {
            setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
          },
        })
        .then((res) => {
          if (res.status == "200") {
            setmessage("Uploaded successfully");
            setInputs((inputs) => ({ ...inputs, logo: res.data.dbPath }));
          }
        })
        .catch((err) => {
          setmessage("upload fail");
        });
    } else {
      setmessage("Select a file to upload");
    }
  };
  const maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 1) {
      const msg = "Only One file can be uploaded at a time";
      event.target.value = null;
      setmessage(msg);

      return false;
    }
    return true;
  };
  const handleSelectChange = (UserGroup, actionMeta) => {
    setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
  };
  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleEdit = () => {
    if (inputs.id) {
      setOpen(true);
      setUpdate(true);
      setview(false);
    } else {
      alert("Select a record to edit");
    }
  };
  const handleView = () => {
    if (inputs.id) {
      setview(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to veiw");
    }
  };
  const fetchGovernancesDetails = (url) => {
    Api.get(url)
      .then(function (response) {       
          setInputs(response.data[0])       

      })
      .catch(function (error) {
      })
      .then(function () {
        // always executed
      })

  };
  const handleSelect = (k, event) => {

    setInputs(k.data);
    fetchGovernancesDetails("api/Governances/" + k.data.id);
  };
  const handleCloseModal = () => {
    setInputs({});
    setOpen(false);
    setview(false);
    setUpdate(false);
  };
  const HandleSave = () => {
    useSave(url, inputs);
    grid.refresh();
  };

  const HandleUpdate = () => {
    useUpdate(url + "/" + inputs.id, inputs);
    grid.refresh();
  };
  const HandleSubmit = (event) => {
    event.preventDefault();
    if (update) {
      HandleUpdate();
    } else {
      HandleSave();
    }
  };
  const CallDeletehook = () => {
    useDelete(url + "/" + inputs.id);
    grid.refresh();
  };
  const HandelDelete = () => {
    if (inputs.id) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  
  const DisabilitiesOptions = [];

  const QualificationsOptions = [];
  const InstitutionsOptions = [];
  const EthnicitiesOptions = [];
  const RolesOptions = [];
  const statusOptions = [
    {
      value: "Active",
      label: "Active",
    },
    {
      value: "In Active",
      label: "In Active",
    },
  ];
  const genderOptions = [
    {
      value: "Male",
      label: "Male",
    },
    {
      value: "Female",
      label: "Female",
    },
  ];
  if (Disabilities.response) {
    Disabilities.response.map((k, i) => {
      let col = {
        value: k.id,
        label: k.name,
      };
      DisabilitiesOptions.push(col);
    });
  }
  if (Ethnicities.response) {
    Ethnicities.response.map((k, i) => {
      let col = {
        value: k.id,
        label: k.name,
      };
      EthnicitiesOptions.push(col);
    });
  }

  if (Qualifications.response) {
    Qualifications.response.map((k, i) => {
      let col = {
        value: k.id,
        label: k.name,
      };
      QualificationsOptions.push(col);
    });
  }

  if (Institutions.response) {
    Institutions.response.map((k, i) => {
      let col = {
        value: k.id,
        label: k.name,
      };
      InstitutionsOptions.push(col);
    });
  }

  if (GovernanceRoles.response) {
    GovernanceRoles.response.map((k, i) => {
      let col = {
        value: k.id,
        label: k.name,
      };
      RolesOptions.push(col);
    });
  }
  const ActionsBtn = () => {
    return (
      <div>
        {useValidateRole(PageRole, "Edit") ? (
          <button
            className="btn btn-primary p-2"
            type="button"
            onClick={handleEdit}
          >
            Update
          </button>
        ) : null}
        &nbsp; &nbsp;
        {useValidateRole(PageRole, "Remove") ? (
          <button onClick={HandelDelete} className="btn btn-danger p-2">
            Delete
          </button>
        ) : null}
        &nbsp;
        <button
          className="btn btn-warning p-2"
          type="button"
          onClick={handleCloseModal}
        >
          Close
        </button>
      </div>
    );
  };
  const styles = {
    control: (base) => ({
      ...base,
      minHeight: "15px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    clearIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  };
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Staff</li>
      </ol>
      <h1 class="page-header mb-3">Governances</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            {useValidateRole(PageRole, "AddNew") ? (
              <button
                onClick={handleOpenModal}
                className="btn btn-primary p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; New &nbsp;
              </button>
            ) : null}
            {useValidateRole(PageRole, "View") ? (
              <button
                onClick={handleView}
                className="btn btn-success p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; View &nbsp;
              </button>
            ) : null}
            {useValidateRole(PageRole, "Edit") ? (
              <button
                onClick={handleEdit}
                className="btn btn-info p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; Edit &nbsp;
              </button>
            ) : null}
            {useValidateRole(PageRole, "Remove") ? (
              <button
                onClick={HandelDelete}
                className="btn btn-danger p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; Delete &nbsp;
              </button>
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
          <GridComponent ref={g => grid = g}
              allowPaging={true}
              allowResizing={true}
              allowFiltering={true}
              allowTextWrap={true}
              rowSelected={(args) => {
                handleSelect(args);
              }}
              dataSource={new DataManager({
                adaptor: new UrlAdaptor(),
                crossDomain: true,
                url: dataurl,
                headers: [{
                  Authorization: "Bearer " + window.sessionStorage.getItem("xtoken")
                }]
              })
              }>
              <ColumnsDirective>               
                <ColumnDirective field='name' headerText='Name' />
                <ColumnDirective field='gender' headerText='Gender' />
                <ColumnDirective field='mobile' headerText='Mobile'  />
                <ColumnDirective field='email' headerText='Email'  />
                <ColumnDirective field='institution' headerText='Institution' />
                <ColumnDirective field='qualification' headerText='qualification' />
                <ColumnDirective field='role' headerText='role' />
              </ColumnsDirective>
              <Inject services={[Page, Sort, Resize, Filter]} />
            </GridComponent>
          </div>
        </div>
      </div>
      <Modal visible={open} width="77%" height="55%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <div
            className="row"
            style={{
              background: "yellow",

              marginLeft: "10px",
              marginRight: "10px",
            }}
          >
            <div class="col-xs-12 center-block text-center">
              {view ? (
                <h3 className="text-center font-weight-bold">
                  <span> {inputs.name} -{inputs.institution ? inputs.institution.name : ""}</span>
                </h3>
              ) : (
                  <h3 className="text-center font-weight-bold">New</h3>
                )}
            </div>
          </div>

          <form className="form-horizontal" onSubmit={HandleSubmit}>
            <div
              style={{ marginLeft: "10px", marginRight: "10px" }}
              className="row"
            >
              <div
                className="col-sm-5"
                style={{ border: "1px solid", marginTop: "5px" }}
              >
                <table className="table table-sm">
                  <tbody>
                    <tr>
                      <td className="font-weight-bold">Name:</td>
                      <td>
                        {" "}
                        {view ? (
                          inputs.name
                        ) : (
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="name"
                              required
                              placeholder
                              value={inputs.name}
                              onChange={handleInputChange}
                            />
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Mobile:</td>
                      <td>
                        {view ? (
                          inputs.mobile
                        ) : (
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="mobile"
                              required
                              value={inputs.mobile}
                              onChange={handleInputChange}
                            />
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Email:</td>
                      <td>
                        {view ? (
                          inputs.email
                        ) : (
                            <input
                              type="email"
                              className="form-control form-control-sm"
                              name="email"
                              required
                              placeholder
                              value={inputs.email}
                              onChange={handleInputChange}
                            />
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Gender:</td>
                      <td>
                        {view ? (
                          inputs.gender
                        ) : (
                            <Select
                              styles={styles}
                              name="gender"
                              value={genderOptions.filter(
                                (option) => option.value === inputs.gender
                              )}
                              onChange={handleSelectChange}
                              options={genderOptions}
                            />
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Qualification:</td>
                      <td>
                        {view ? (
                          inputs.qualification ? (
                            inputs.qualification.name
                          ) : (
                              "N/A"
                            )
                        ) : (
                            <Select
                              styles={styles}
                              name="qualificationid"
                              value={QualificationsOptions.filter(
                                (option) =>
                                  option.value === inputs.qualificationid
                              )}
                              onChange={handleSelectChange}
                              options={QualificationsOptions}
                            />
                          )}
                      </td>
                    </tr>{" "}
                    <tr>
                      <td className="font-weight-bold">
                        Disability Description:
                      </td>
                      <td>
                        {view ? (
                          inputs.disability ? (
                            inputs.disability.name
                          ) : (
                              "N/A"
                            )
                        ) : (
                            <Select
                              styles={styles}
                              name="disabilityId"
                              value={DisabilitiesOptions.filter(
                                (option) => option.value === inputs.disabilityId
                              )}
                              onChange={handleSelectChange}
                              options={DisabilitiesOptions}
                            />
                          )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="col-sm-5"
                style={{
                  borderTop: "1px solid",
                  borderBottom: "1px solid",
                  marginTop: "5px",
                }}
              >
                <table className="table table-sm">
                  <tbody>
                    <tr>
                      <td className="font-weight-bold">Instituition:</td>
                      <td>
                        {view ? (
                          inputs.institution ? (
                            inputs.institution.name
                          ) : (
                              "N/A"
                            )
                        ) : (
                            <Select
                              styles={styles}
                              name="institutionId"
                              value={InstitutionsOptions.filter(
                                (option) => option.value === inputs.institutionId
                              )}
                              onChange={handleSelectChange}
                              options={InstitutionsOptions}
                            />
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Role:</td>
                      <td>
                        {view ? (
                          inputs.role ? (
                            inputs.role.name
                          ) : (
                              "N/A"
                            )
                        ) : (
                            <Select
                              styles={styles}
                              name="roleId"
                              value={RolesOptions.filter(
                                (option) => option.value === inputs.roleId
                              )}
                              onChange={handleSelectChange}
                              options={RolesOptions}
                            />
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Date of Appointed:</td>
                      <td>
                        {view ? (
                          inputs.dateAppointed ? (
                            dateFormat(inputs.dateAppointed, "mediumDate")
                          ) : (
                              "N/A"
                            )
                        ) : (
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              name="dateAppointed"
                              required
                              value={
                                inputs.dateAppointed
                               
                              }
                              onChange={handleInputChange}
                            />
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Date of Inaugrated:</td>
                      <td>
                        {view ? (
                          inputs.dateInaugrated ? (
                            dateFormat(inputs.dateInaugrated, "mediumDate")
                          ) : (
                              "N/A"
                            )
                        ) : (
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              name="dateInaugrated"
                              required
                              value={
                                inputs.dateInaugrated
                                 
                              }
                              onChange={handleInputChange}
                            />
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Ethnicity:</td>
                      <td>
                        {view ? (
                          inputs.ethnicity ? (
                            inputs.ethnicity.name
                          ) : (
                              "N/A"
                            )
                        ) : (
                            <Select
                              styles={styles}
                              name="ethnicityId"
                              value={EthnicitiesOptions.filter(
                                (option) => option.value === inputs.ethnicityId
                              )}
                              onChange={handleSelectChange}
                              options={EthnicitiesOptions}
                            />
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td className="font-weight-bold">Status:</td>
                      <td>
                        {view ? (
                          inputs.status
                        ) : (
                            <Select
                              styles={styles}
                              name="status"
                              value={statusOptions.filter(
                                (option) => option.value === inputs.status
                              )}
                              onChange={handleSelectChange}
                              options={statusOptions}
                            />
                          )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="col-sm-2"
                style={{
                  borderRight: "1px solid",
                  borderTop: "1px solid",
                  borderBottom: "1px solid",
                  marginTop: "5px",
                }}
              >
                <img
                  style={{ height: "120px", width: "100px" }}
                  src={process.env.REACT_APP_BASE_URL + inputs.logo}
                  alt=""
                />
                <br />
                {view ? null : (
                  <div className="form-group">
                    <label htmlFor="Datereceived" className="fontWeight-bold">
                      Photo
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      name="file"
                      onChange={onChangeHandler}
                      multiple
                    />
                    <div class="form-group">
                      <Progress max="100" color="success" value={loaded}>
                        {Math.round(loaded, 2)}%
                      </Progress>
                      <button
                        type="button"
                        class="btn btn-success "
                        onClick={onClickHandler}
                      >
                        Upload
                      </button>
                    </div>

                    <span class="upload">{message}</span>
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                "justify-content": "flex-end",
                margin: "10px",
              }}
            >
              {view ? (
                <ActionsBtn />
              ) : (
                  <div class="d-flex flex-row">
                    <button className="btn btn-primary p-2" type="submit">
                      Submit
                  </button>
                  &nbsp;
                    <button
                      className="btn btn-warning p-2"
                      type="button"
                      onClick={handleCloseModal}
                    >
                      Close
                  </button>
                  </div>
                )}
            </div>
          </form>
        </div>
      </Modal>
      :
    </div>
  );
};

export default Governances;
